<div class="container-fluid">
  <mat-card *transloco="let t">
    <mat-card-header>
      <mat-card-title>
        {{ message }}
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <p>{{ t('reference.message.pageDoesNotExist') }}</p>
      <a mat-button color="primary" routerLink="/" class="mt-2">
        <mat-icon>arrow_back</mat-icon>
        {{ t('action.returnHome') }}
      </a>
    </mat-card-content>
  </mat-card>
</div>
